// Кеш транзакцій для миттєвого показу при монтуванні екранів.
// localStorage сам по собі ненадійний: фото отримувачів зберігаються в
// транзакціях як data-URL, і список може не влазити в квоту — тоді запис
// мовчки падає, а при поверненні на екран показується застарілий список
// (найновіша транзакція зникає, доки не прийде відповідь Firebase).
// Тому головне джерело — пам'ять (живе всю сесію), localStorage — запасне
// (між перезапусками застосунку).
const memory = new Map();

const storageKey = (chatId) => `transactions_${chatId}`;

export function readCachedTransactions(chatId) {
  if (memory.has(chatId)) return memory.get(chatId);
  try {
    const cached = localStorage.getItem(storageKey(chatId));
    if (cached) return JSON.parse(cached);
  } catch (e) { /* ignore */ }
  return null;
}

// localStorage перезаписуємо лише коли дані змінились — це дорога операція
export function cacheTransactions(chatId, arr) {
  const json = JSON.stringify(arr);
  const prev = readCachedTransactions(chatId);
  memory.set(chatId, arr);
  if (prev === null || JSON.stringify(prev) !== json) {
    try { localStorage.setItem(storageKey(chatId), json); } catch (e) { /* ignore */ }
  }
}
